export const GET_AUTOPARK_TRANSPORT_INFO = 'autopark-transport-modal/GET_AUTOPARK_TRANSPORT_INFO';
export const getAutoparkTransportInfoAction = payload => ({
	type: GET_AUTOPARK_TRANSPORT_INFO,
	payload,
});

export const SET_AUTOPARK_TRANSPORT_INFO = 'autopark-transport-modal/SET_AUTOPARK_TRANSPORT_INFO';
export const setAutoparkTransportInfoAction = payload => ({
	type: SET_AUTOPARK_TRANSPORT_INFO,
	payload,
});

export const SET_IS_AUTOPARK_TRANSPORT_INFO_LOADING = 'autopark-transport-modal/SET_IS_AUTOPARK_TRANSPORT_INFO_LOADING';
export const setIsAutoparkTransportInfoLoadingAction = payload => ({
	type: SET_IS_AUTOPARK_TRANSPORT_INFO_LOADING,
	payload,
});

export const GET_TRANSPORT_TYPES_LIST = 'autopark-transport-modal/GET_TRANSPORT_TYPES_LIST';
export const getTransportTypesListAction = payload => ({
	type: GET_TRANSPORT_TYPES_LIST,
	payload,
});

export const SET_TRANSPORT_TYPES_LIST = 'autopark-transport-modal/SET_TRANSPORT_TYPES_LIST';
export const setTransportTypesListAction = payload => ({
	type: SET_TRANSPORT_TYPES_LIST,
	payload,
});

export const SET_IS_TRANSPORT_TYPES_LIST_LOADING = 'autopark-transport-modal/SET_IS_TRANSPORT_TYPES_LIST_LOADING';
export const setIsTransportTypesListLoadingAction = payload => ({
	type: SET_IS_TRANSPORT_TYPES_LIST_LOADING,
	payload,
});

export const GET_AUTOPARK_TRANSPORT_TARIFF_TYPES_LIST =
	'autopark-transport-modal/GET_AUTOPARK_TRANSPORT_TARIFF_TYPES_LIST';
export const getAutoparkTransportTariffTypesListAction = payload => ({
	type: GET_AUTOPARK_TRANSPORT_TARIFF_TYPES_LIST,
	payload,
});

export const SET_AUTOPARK_TRANSPORT_TARIFF_TYPES_LIST =
	'autopark-transport-modal/SET_AUTOPARK_TRANSPORT_TARIFF_TYPES_LIST';
export const setAutoparkTransportTariffTypesListAction = payload => ({
	type: SET_AUTOPARK_TRANSPORT_TARIFF_TYPES_LIST,
	payload,
});

export const SET_IS_AUTOPARK_TRANSPORT_TARIFF_TYPES_LIST_LOADING =
	'autopark-transport-modal/SET_IS_AUTOPARK_TRANSPORT_TARIFF_TYPES_LIST_LOADING';
export const setIsAutoparkTransportTariffTypesListLoadingAction = payload => ({
	type: SET_IS_AUTOPARK_TRANSPORT_TARIFF_TYPES_LIST_LOADING,
	payload,
});

export const GET_ADDRESSES_LIST = 'autopark-transport-modal/GET_ADDRESSES_LIST';
export const getAddressesListAction = payload => ({
	type: GET_ADDRESSES_LIST,
	payload,
});

export const SET_ADDRESSES_LIST = 'autopark-transport-modal/SET_ADDRESSES_LIST';
export const setAddressesListAction = payload => ({
	type: SET_ADDRESSES_LIST,
	payload,
});

export const SET_IS_ADDRESSES_LIST_LOADING = 'autopark-transport-modal/SET_IS_ADDRESSES_LIST_LOADING';
export const setIsAddressesListLoadingAction = payload => ({
	type: SET_IS_ADDRESSES_LIST_LOADING,
	payload,
});

export const CREATE_AUTOPARK_TRANSPORT = 'autopark-transport-modal/CREATE_AUTOPARK_TRANSPORT';
export const createAutoparkTransportAction = payload => ({
	type: CREATE_AUTOPARK_TRANSPORT,
	payload,
});

export const SET_IS_AUTOPARK_TRANSPORT_CREATING = 'autopark-transport-modal/SET_IS_AUTOPARK_TRANSPORT_CREATING';
export const setIsAutoparkTransportCreatingAction = payload => ({
	type: SET_IS_AUTOPARK_TRANSPORT_CREATING,
	payload,
});

export const UPDATE_AUTOPARK_TRANSPORT = 'autopark-transport-modal/UPDATE_AUTOPARK_TRANSPORT';
export const updateAutoparkTransportAction = payload => ({
	type: UPDATE_AUTOPARK_TRANSPORT,
	payload,
});

export const SET_IS_AUTOPARK_TRANSPORT_UPDATING = 'autopark-transport-modal/SET_IS_AUTOPARK_TRANSPORT_UPDATING';
export const setIsAutoparkTransportUpdatingAction = payload => ({
	type: SET_IS_AUTOPARK_TRANSPORT_UPDATING,
	payload,
});

export const DELETE_AUTOPARK_TRANSPORT = 'autopark-transport-modal/DELETE_AUTOPARK_TRANSPORT';
export const deleteAutoparkTransportAction = payload => ({
	type: DELETE_AUTOPARK_TRANSPORT,
	payload,
});

export const SET_IS_AUTOPARK_TRANSPORT_DELETING = 'autopark-transport-modal/SET_IS_AUTOPARK_TRANSPORT_DELETING';
export const setIsAutoparkTransportDeletingAction = payload => ({
	type: SET_IS_AUTOPARK_TRANSPORT_DELETING,
	payload,
});

export const RESET_STATE = 'autopark-transport-modal/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
